import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { FIELDS_INVOICE_COPY } from './validation/fields';
import Form from './Form';
import { schema } from './validation/schema';

const InvoiceCopy = ({ ...props }) => {
  const { issueForm, mobile, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm={issueForm}
        mobile={mobile}
        buttonTitle="Enviar solicitud"
        title=""
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={FIELDS_INVOICE_COPY}
          />
        }
        data={data}
        fields={FIELDS_INVOICE_COPY}
        formName="InvoiceCopy"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        schema={schema}
        motiveId={motiveId}
        typeId={typeId}
      />
    </React.Fragment>
  );
};

InvoiceCopy.propTypes = {
  mobile: PropTypes.bool,
  issueForm: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default InvoiceCopy;
